import gql from 'graphql-tag';
import { useCustomQuery } from '../../../../logic/api/graphQL/useCustomQuery';

export function useGetBestTrafficPagesGq(command: CommandGq) {
  const query = useCustomQuery<DataGq, VariablesGq>(gqTag, {
    variables: { command },
    fetchPolicy: 'cache-and-network',
  });

  return {
    query,
    result: (query?.data ?? query?.previousData)?.projects?.getBestTrafficPages,
  };
}

export const gqTag = gql`
  query GetBestTrafficPages($command: GetBestTrafficPagesCommand!) {
    projects {
      getBestTrafficPages(command: $command) {
        bestTrafficPages {
          url
          totalTraffic
          totalVolume
          keywordCount
          rD
          bestKeyword
          bestKeywordTraffic
          bestKeywordVolume
          bestKeywordRank
        }
      }
    }
  }
`;

interface DataGq {
  readonly projects: {
    readonly getBestTrafficPages: ResponseGq;
  };
}

export interface ResponseGq {
  readonly bestTrafficPages?: TopPageGq[];
}

export interface TopPageGq {
  readonly url: string;
  readonly totalTraffic: number;
  readonly totalVolume: number;
  readonly keywordCount: number;
  readonly rD: number;
  readonly bestKeyword: string;
  readonly bestKeywordTraffic: number;
  readonly bestKeywordVolume: number;
  readonly bestKeywordRank: number;
}

export interface VariablesGq {
  readonly command: CommandGq;
}
export interface CommandGq {
  readonly projectId: number;
  readonly limitItems: number;
  readonly projectDomainId: number;
}
